import { useState } from 'react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useHistorialUnidad } from './api';
import type { ColumnDef } from '@tanstack/react-table';
import type { Visita } from '@condo/contracts';
import { DataTable } from '@/components/common/data-table';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface Props {
  unidades: Array<{ unidadId: string; unidadNumero: string }>;
}

export function MiUnidadTab({ unidades }: Props) {
  const { condoId } = useCondoContext();
  const [selected, setSelected] = useState(unidades[0]?.unidadId ?? '');
  const { data, isLoading } = useHistorialUnidad(condoId, selected);

  const columns: ColumnDef<Visita, unknown>[] = [
    { accessorKey: 'visitorNombre', header: 'Visitante' },
    { accessorKey: 'tipo', header: 'Tipo' },
    { accessorKey: 'origen', header: 'Origen' },
    {
      accessorKey: 'ingresoAt',
      header: 'Ingreso',
      cell: ({ row }) =>
        format(new Date(row.original.ingresoAt), 'd MMM, HH:mm', {
          locale: es,
        }),
    },
    {
      accessorKey: 'egresoAt',
      header: 'Egreso',
      cell: ({ row }) =>
        row.original.egresoAt
          ? format(new Date(row.original.egresoAt), 'd MMM, HH:mm', {
              locale: es,
            })
          : '— aún dentro',
    },
  ];

  return (
    <div>
      {unidades.length > 1 && (
        <select
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="mb-4 rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)] px-3 py-2 text-sm"
        >
          {unidades.map((u) => (
            <option key={u.unidadId} value={u.unidadId}>
              Unidad {u.unidadNumero}
            </option>
          ))}
        </select>
      )}
      <DataTable
        columns={columns}
        data={data?.items ?? []}
        isLoading={isLoading}
        empty={<span className="text-sm">Sin visitas registradas aún.</span>}
      />
    </div>
  );
}
